// firebase-config.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCQEeyCaS8lw2bvVZFBuoKnLJYMQfVWAv8",
  authDomain: "direktstays-da080.firebaseapp.com",
  projectId: "direktstays-da080",
  storageBucket: "direktstays-da080.firebasestorage.app",
  messagingSenderId: "1027044290960",
  appId: "1:1027044290960:web:e599ed625751ac6cb18315",
  measurementId: "G-113VKVYEQ5",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
